module.exports = __webpack_public_path__ + "img/shape_tracerstudy_copy.17be3dff.svg";